import React from 'react';
import { useTranslation } from 'react-i18next';
import { trackEvent } from '../analytics';

/**
 * LanguageSwitcher — Toggle between EN and FR.
 * Shows the label of the *other* language (click FR to switch to French).
 * Becomes a dropdown when a 3rd language is added.
 */
const LanguageSwitcher = ({ className = '' }) => {
  const { t, i18n } = useTranslation();

  const toggle = () => {
    const from = i18n.language.startsWith('fr') ? 'fr' : 'en';
    const next = from === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(next);
    trackEvent('language_changed', { from, to: next });
  };

  return (
    <button
      className={`language-switcher ${className}`}
      onClick={toggle}
      aria-label={`Switch language to ${i18n.language.startsWith('fr') ? 'English' : 'Français'}`}
    >
      {t('language.switchTo')}
    </button>
  );
};

export default LanguageSwitcher;
